import { useEffect, useState } from 'react';
import { activateMessage } from '../api';

interface Props { code: string; }

export function ActivatePage({ code }: Props) {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    activateMessage(code)
      .then(() => setStatus('success'))
      .catch(err => { setStatus('error'); setErrorMsg(err.message); });
  }, [code]);

  return (
    <div className="min-h-screen bg-[#0d0d1a] flex items-center justify-center p-4">
      <div className="bg-[#1a1a2e] rounded-2xl p-8 max-w-md w-full text-center border border-[#2d2d4e]">
        {status === 'loading' && (
          <>
            <div className="text-4xl mb-4 animate-pulse">⏳</div>
            <p className="text-slate-400">Publishing your message…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-5xl mb-4">🎉</div>
            <h2 className="text-2xl font-bold text-violet-400 mb-2">You're on the card!</h2>
            <p className="text-slate-400 mb-6">Your message is now live.</p>
            <a
              href="/"
              className="px-6 py-3 bg-violet-600 hover:bg-violet-700 text-white rounded-lg transition-colors inline-block font-medium"
            >
              See the card →
            </a>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-5xl mb-4">🔗</div>
            <h2 className="text-xl font-bold text-red-400 mb-2">Link not valid</h2>
            <p className="text-slate-400">
              {errorMsg || 'This activation link has already been used or is no longer valid.'}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
